import ApplyableSampleToggle from "@/features/sample_item/components/ApplyableSampleToggle";
import { ProductSortPulldown } from "@/features/sort";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import clsx from "clsx";
import { FC } from "react";

interface Props {
  query: ProductSearchQueryParameter;
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
  availableSample?: boolean;
  sortable: boolean;
}

export const ProductSearchHeader: FC<Props> = ({
  availableSample = true,
  sortable,
  query,
  queryController,
}) => {
  return (
    <div
      className={clsx(
        "w-full flex items-center",
        availableSample ? "justify-between" : "justify-end",
      )}
    >
      <ApplyableSampleToggle
        checked={query.in_stock ? Boolean(query.in_stock) : false}
        queryController={queryController}
      />

      {sortable && (
        <ProductSortPulldown
          selectedSort={query.sort}
          queryController={queryController}
        />
      )}
    </div>
  );
};
